<template>
  <div class="pc-search">
    
    <el-form class="pc-search-main-formOne"
      :model="keywordData" 
      :inline="true" 
    >
      <el-form-item label="院校" class="realName">
        <!-- <el-input v-model="keywordData.realName" placeholder="同济大学"></el-input> -->
        <el-select v-model="keywordData.realName" placeholder="查询院校" @change="choiceUniversity" clearable >
          <el-option v-for="(item,index) in universityList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="状态"  class="status">
        <el-select v-model="keywordData.status" placeholder="有效" clearable >
          <el-option label="无效" :value="0"></el-option>
          <el-option label="有效" :value="1"></el-option>
          
        </el-select>
      </el-form-item>
    </el-form>


    <button class="pc-search-clickBtn" @click="search">筛选</button>

  </div>
</template>



<script>
import {getDictionaries,getUniversities} from './universityList.gql'
export default {
  data(){
    return {
      keywordData: {
        realName: null,
        tag: null,
        wupenLegend: null,
        status: null,
        continent: null,
        country: null,
        city: null,
      },
      // 大洲字段
      continentList:[],
      // 国家字段
      countryList:[],
      // 城市字段
      cityList:[],
      // 大学下拉列表
      universityList:[],
      universityArgs:{
        take:0,
        status:-1,

      }
    }
  },
  mounted() {
    this.getUniversities()
  },
  methods: {
    getUniversities() {
      this.$global
        .GraphqlQuery(this, getUniversities, this.universityArgs)
        .then(res => {
          this.universityList = res.data;
        });
    },
    choiceUniversity(){

    },
    // 获取学校
    search () {
      this.$emit( 'search', JSON.parse(JSON.stringify(this.keywordData)) )
    }
  }
}
</script>



<style lang="scss" scoped>
.pc-search {
  position: relative;
  /deep/ .el-form-item {
    margin-bottom: 0 !important;
  }
  /deep/ .el-form--inline .el-form-item {
    margin-right: 0 !important;
  }


  /deep/ .el-input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // 预设两行
  /deep/ .el-form-item__label {
    font-family: $chinese;
    font-size: 14px;
    font-weight: bold;
    color: $mainTitle;
  }
  /deep/ .el-input__inner {
    margin-right: 40px;
    height: 40px;
    padding: 0 10px;
  }
  /deep/ .pc-search-main-formTwo .el-input__inner {
    margin-right: 9px;
  }
  /deep/ .el-input__suffix {
    right: 45px;
  }
  /deep/ .pc-search-main-formTwo .el-input__suffix {
    right: 13px;
  }
  // 第一行 名称
  /deep/ .realName .el-input__inner
  {
    width: 240px;
  }
  // 第一行 标签
    /deep/ .tag .el-input__inner{
      width: 240px;
  }
  // 第一行 wupen联盟 状态
  /deep/ .wupenLegend .el-input__inner,
  /deep/ .status .el-input__inner{
      width: 120px;
  }
  // 第二行 地域
  /deep/ .continent .el-input__inner,
  /deep/ .country .el-input__inner,
  /deep/ .city .el-input__inner
  {
    width: 120px;
  } 
  .pc-search-main-formTwo {
    margin-top: 19px;
  }

  .pc-search-clickBtn {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 90px;
    // height: 30px;
    padding: 10px 29px 14px;
    background: $blueBtn;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: $chinese;
    font-size: 16px;
    color: white;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/university/components/RinkingUniversitySearch.vue